// extracted by mini-css-extract-plugin
module.exports = {"container":"basedetail_container__2G-F8","content":"basedetail_content__2jupc","img":"basedetail_img__5N2Vg"};